'use client';

import type { ReactNode } from 'react';
import { useCookieConsent } from '@/contexts/consent';
import { GoogleOneTap } from '@/features/google-one-tap';
import { PublicNotifications } from '@/features/notifications';

function FunctionalGoogleOneTap() {
    const { functionalAllowed } = useCookieConsent();
    return functionalAllowed ? <GoogleOneTap /> : null;
}

/** 只装公开区特有的业务；Auth/API/身份桥在 `(application)` 层。 */
export function PublicProviders({ children }: { /** 公开页面内容。 */ children: ReactNode }) {
    return (
        <>
            <PublicNotifications>{children}</PublicNotifications>
            <FunctionalGoogleOneTap />
        </>
    );
}
